import _defineProperty from "/var/www/html/meameal/prod/front_meameal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { NotificationPlacements } from '../interface';
var placementAlignProperty = {
  topLeft: 'left',
  topRight: 'right',
  bottomLeft: 'left',
  bottomRight: 'right',
  top: 'left',
  bottom: 'left'
};

var genPlacementStackStyle = function genPlacementStackStyle(token, placement) {
  var _$concat$concat;

  var componentCls = token.componentCls;
  return _defineProperty({}, "".concat(componentCls, "-").concat(placement), _defineProperty({}, "&".concat(componentCls, "-stack > ").concat(componentCls, "-notice-wrapper"), (_$concat$concat = {}, _defineProperty(_$concat$concat, placement.startsWith('top') ? 'top' : 'bottom', 0), _defineProperty(_$concat$concat, placementAlignProperty[placement], {
    value: 0,
    _skip_check_: true
  }), _$concat$concat)));
};

var genStackChildrenStyle = function genStackChildrenStyle(token) {
  var childrenStyle = {};

  for (var i = 1; i < token.notificationStackLayer; i++) {
    childrenStyle["&:nth-last-child(".concat(i + 1, ")")] = _defineProperty({
      overflow: 'hidden'
    }, "& > ".concat(token.componentCls, "-notice"), {
      opacity: 0,
      transition: "opacity ".concat(token.motionDurationMid)
    });
  }

  return Object.assign(_defineProperty({}, "&:not(:nth-last-child(-n+".concat(token.notificationStackLayer, "))"), {
    opacity: 0,
    overflow: 'hidden',
    color: 'transparent',
    pointerEvents: 'none'
  }), childrenStyle);
};

var genStackedNoticeStyle = function genStackedNoticeStyle(token) {
  var childrenStyle = {};

  for (var i = 1; i < token.notificationStackLayer; i++) {
    childrenStyle["&:nth-last-child(".concat(i + 1, ")")] = {
      background: token.colorBgBlur,
      backdropFilter: 'blur(10px)',
      '-webkit-backdrop-filter': 'blur(10px)'
    };
  }

  return Object.assign({}, childrenStyle);
};

var genStackStyle = function genStackStyle(token) {
  var _Object$assign2;

  var componentCls = token.componentCls;
  return Object.assign((_Object$assign2 = {}, _defineProperty(_Object$assign2, "".concat(componentCls, "-stack"), _defineProperty({}, "& > ".concat(componentCls, "-notice-wrapper"), Object.assign({
    transition: "all ".concat(token.motionDurationSlow, ", backdrop-filter 0s"),
    position: 'absolute'
  }, genStackChildrenStyle(token)))), _defineProperty(_Object$assign2, "".concat(componentCls, "-stack:not(").concat(componentCls, "-stack-expanded)"), _defineProperty({}, "& > ".concat(componentCls, "-notice-wrapper"), Object.assign({}, genStackedNoticeStyle(token)))), _defineProperty(_Object$assign2, "".concat(componentCls, "-stack").concat(componentCls, "-stack-expanded"), _defineProperty({}, "& > ".concat(componentCls, "-notice-wrapper"), {
    '&:not(:nth-last-child(-n + 1))': _defineProperty({
      opacity: 1,
      overflow: 'unset',
      color: 'inherit',
      pointerEvents: 'auto'
    }, "& > ".concat(token.componentCls, "-notice"), {
      opacity: 1
    }),
    '&:after': {
      content: '""',
      position: 'absolute',
      height: token.margin,
      width: '100%',
      insetInline: 0,
      bottom: token.calc(token.margin).mul(-1).equal(),
      background: 'transparent',
      pointerEvents: 'auto'
    }
  })), _Object$assign2), NotificationPlacements.map(function (placement) {
    return genPlacementStackStyle(token, placement);
  }).reduce(function (acc, cur) {
    return Object.assign(Object.assign({}, acc), cur);
  }, {}));
};

export default genStackStyle;